import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const Deratisation = lazy(() => import('../pages/services/Deratisation'));
const Desinsectisation = lazy(() => import('../pages/services/Desinsectisation'));
const Desinfection = lazy(() => import('../pages/services/Desinfection'));
const Admin = lazy(() => import('../pages/admin/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/deratisation',
    element: <Deratisation />,
  },
  {
    path: '/desinsectisation',
    element: <Desinsectisation />,
  },
  {
    path: '/desinfection',
    element: <Desinfection />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;